import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FeedbackOptionButtons = ({
  selectedOptions,
  onOptionSelect,
  feedbackOptions
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: feedbackOptions.map(option => {
      if (isNaN(Number(option))) {
        return /*#__PURE__*/_jsx(Checkbox, {
          "data-test-id": "feedback-button",
          size: "sm",
          display: "block",
          checked: selectedOptions.includes(option.key),
          onChange: () => onOptionSelect(option.key),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: option.I18LabelKey
          })
        }, option.key);
      }
      return null;
    })
  });
};
export default FeedbackOptionButtons;